import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 324px;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    margin: 0 auto;
  }
`;

export const Container = styled.div`
  margin-bottom: 26px;
  font-size: 1.4rem;
`;

export const Title = styled.span`
  font-weight: bold;
  margin-bottom: 10px;
  font-family: ${({
    theme: {
      fonts: { archivo },
    },
  }) => archivo};
  display: flex;
  justify-content: space-between;
`;

export const Row = styled.div`
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-between;
`;

export const Label = styled.span`
  color: ${({
    theme: {
      colors: {
        functional: { darkGray },
      },
    },
  }) => darkGray};
`;

export const Value = styled.span``;
export const Highlighted = styled.span`
  font-size: 2.2rem;
  font-weight: 700;
  color: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
`;

export const PercentageBarWrap = styled.div`
  position: relative;
  border: 1px
    ${({
      theme: {
        colors: {
          functional: { gray5 },
        },
      },
    }) => gray5}
    solid;
  height: 10px;
  margin-top: 2px;
  width: 100px;
  border-radius: 10px;
`;

/// TODO make % dynamic
/// TODO add variant background colors: yellow below 35%, red below 11%
export const PercentageBar = styled.div`
  position: absolute;
  top: 1px;
  bottom: 1px;
  right: 1px;
  width: 51%;
  border-radius: 10px;
  background: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
`;

export const PercentageValue = styled.span`
  position: absolute;
  width: 40px;
  display: block;
  left: -40px;
  line-height: 10px;
  color: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
`;
